export default __webpack_public_path__ + "static/media/background01.2f360e3d.jpg";